// Function loadHorizontalGalleryBlock loads the HorizontalGalleryBlock class by dynamically importing the js on demand if needed

export function loadHorizontalYoutubeGalleryBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-horizontal-youtube-gallery-block-chunk" */ '../widgets/horizontalYoutubeGalleryBlock').then(wg => {

		const { HorizontalYoutubeGalleryBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="HorizontalYoutubeGalleryBlock"]');

		if(!$wg) {
			// console.info('HorizontalYoutubeGalleryBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HorizontalYoutubeGalleryBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new HorizontalYoutubeGalleryBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HorizontalYoutubeGalleryBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the HorizontalGalleryBlock widget');

}
